// auth middle ware to check if the user is logged in
export default ({ redirect, store }) => {
  const user = store.getters['auth/user']
  // eslint-disable-next-line no-extra-boolean-cast
  let notLoggedIn = !Boolean(user)
  if (notLoggedIn) {
    redirect({ name: 'Login' })
  }
}
